var Handlebars = require('/src/melia-widget/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<div class=\"lmm-maps-widget-container "
    + container.escapeExpression(((helper = (helper = helpers.className || (depth0 != null ? depth0.className : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"className","hash":{},"data":data}) : helper)))
    + "\">\n    <div class=\"map-container\"></div>\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./lmm-widget/src/widget/widget.hbs
// module id = 211
// module chunks = 1